import React from 'react';
import './UniversityPage.css';

const UniversityPage4 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>MEDICINE AND SURGERY- POLITECHNO DI MARCHE </h1>
                    <h2>Medicine and Surgery at Università Politecnica delle Marche: A Fusion of Medicine and Technology</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The Medicine and Surgery program at Università Politecnica delle Marche stands out as a forward-thinking course designed to train the next generation of doctors equipped with both medical expertise and advanced technological skills. Unlike traditional medical programs, this course integrates medicine with engineering, bioinformatics, and artificial intelligence, preparing students to not only use but also contribute to the development of cutting-edge medical technologies. With a strong emphasis on innovation, students gain hands-on experience through high-tech simulators, virtual reality tools, and bioengineering labs, ensuring they are ready to tackle the evolving challenges of modern healthcare. By focusing on fields like genomics, big data, and remote medical technologies, this program aims to shape professionals who will revolutionize patient care and medical research.</p>
                    <a href="https://www.orienta.univpm.it/cosa-si-studia/medicina-e-chirurgia/medicine-and-technology/">Learn More</a>
                </section>

                <section className="ranking">
                    <h2>International Ranking</h2>
                    <p>Università Politecnica delle Marche (UNIVPM) has significantly improved its position in the 20th edition of the QS World University Rankings, now placed in the 720-730 range globally, up from the 801-1000 range in the previous edition. This ranking, which focuses on employability and sustainability, recognizes UNIVPM's strength in research, particularly in citations and its international research network. Additionally, the 2022 CENSIS report ranks UNIVPM 5th among Italian universities with student populations between 10,000 and 20,000.</p>
                    <a href="https://www.international.univpm.it/the-university/about-univpm/rankings/">University Rankings</a>
                </section>

                <section className="seats-available">
                    <h2>Seats Available</h2>
                    <p>There are <strong>80 available seats</strong> for the single-cycle master's degree course in 'Medicine and Surgery':</p>
                    <ul>
                        <li><strong>20 seats</strong> are reserved for EU students.</li>
                        <li><strong>60 seats</strong> are reserved for extra-EU students.</li>
                    </ul>
                    <p>If the 60 seats for extra-EU students are not filled, EU candidates will be able to access them.</p>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Scores and Cut-Offs (Past Years)</h2>
                    <p>Medicine and Surgery course, named <strong>Medicine and Technology (M&T)</strong> in Ancona, started in 2022. The IMAT cut-offs for the past two years are mentioned below:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Academic Year</th>
                                    <th>Non-EU Cut-Off</th>
                                    <th>EU Cut-Off</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2023</td>
                                    <td>43.0</td>
                                    <td>First: 37.5 / Last: 35.3</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>60.3</td>
                                    <td>First: 60.2</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="why-choose">
                    <h2>Why Choose Politecnica delle Marche for Medicine?</h2>
                    <p>This unique program differs from other existing courses in the LM-41 (Medicine and Surgery) class by offering an interdisciplinary approach that combines medical knowledge with technological advancements. The goal is to create a 'new doctor'—not just a practitioner but also an innovator who actively contributes to medical technology development.</p>
                    <p>Key aspects of the program include:</p>
                    <ul>
                        <li><strong>Integration of Medicine and Engineering:</strong> A curriculum that bridges healthcare with bioengineering and computational sciences.</li>
                        <li><strong>Hands-on Training:</strong> Access to cutting-edge simulators, procedural software, and virtual reality labs.</li>
                        <li><strong>Focus on Technological Innovation:</strong> Study areas include genomics, big data, artificial intelligence, and remote healthcare solutions.</li>
                        <li><strong>Highly Interactive Learning:</strong> Use of virtual reality, skill labs, and bioengineering facilities for real-world training.</li>
                    </ul>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>To be eligible for the Medicine and Surgery program at Università Politecnica delle Marche, students must meet the following requirements:</p>
                    <ul>
                        <li>A valid high school diploma equivalent to the Italian education system.</li>
                        <li>A strong IMAT (International Medical Admissions Test) score.</li>
                        <li>Proof of English proficiency (minimum B2 level), if required.</li>
                    </ul>
                </section>

                <section className="unique-curriculum">
                    <h2>Unique Integrated Curriculum</h2>
                    <p>The proposed training path is designed to merge the skills of a traditional doctor with those of a biomedical engineer. This is achieved through an integrated structure combining the Master's Degree in Medicine and Surgery (LM/41) with a Three-Year Degree in Biomedical Engineering (L/8). The integration spans the entire six-year program, alternating between medical and bioengineering disciplines.</p>
                    <ul>
                        <li><strong>First Three Years:</strong> Focus on integrating medical and engineering disciplines, ensuring students build a solid foundation in both fields.</li>
                        <li><strong>Final Three Years:</strong> Primarily dedicated to clinical training and professional activities, emphasizing the application of technological innovations in clinical practice.</li>
                        <li><strong>Engineering Courses:</strong> Concentrated in the first three years (first semester), where students attend classes and engage in practical engineering training at the Monte D'Ago Engineering Campus.</li>
                        <li><strong>Additional Credits:</strong> Medicine & Technology students acquire 30 extra University Educational Credits beyond the standard 360 required for the Medicine and Surgery degree. This allows them to request a <strong>Biomedical Engineering degree</strong> upon program completion.</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Curriculum</h2>
                    <p>The program spans six years and is divided into pre-clinical and clinical phases. The curriculum integrates medical sciences with technological advancements and includes:</p>

                    <h3>First Year</h3>
                    <ul>
                        <li>Applied Biology and Genetics</li>
                        <li>Histology</li>
                        <li>Experimental Physics</li>
                        <li>Chemical Basis of Technologies</li>
                        <li>Mathematical Analysis and Geometry</li>
                        <li>Human Microscopic Anatomy</li>
                        <li>Human Anatomy I</li>
                        <li>Biochemistry</li>
                        <li>Human Physiology</li>
                        <li>Pharmacological Basis of Therapeutics I</li>
                        <li>Professionalizing Activities</li>
                        <li>Elective Teaching Activities (Medicine & Biomedical Engineering)</li>
                    </ul>

                    <h3>Second Year</h3>
                    <ul>
                        <li>Medical Statistics</li>
                        <li>Mechanics Applied to Machines</li>
                        <li>Industrial Bioengineering</li>
                        <li>Medical Informatics</li>
                        <li>Microbiology and Clinical Microbiology</li>
                        <li>General Pathology (Immunology)</li>
                        <li>Lab Technical Science and Medicine</li>
                        <li>Histology (Tissue Engineering)</li>
                        <li>Human Anatomy II</li>
                        <li>Biochemistry II</li>
                        <li>Human Physiology II</li>
                        <li>Professionalizing Activities</li>
                        <li>Elective Teaching Activities (Medicine & Biomedical Engineering)</li>
                    </ul>

                    <h3>Third Year</h3>
                    <ul>
                        <li>Electronic and Computer Bioengineering</li>
                        <li>Electronics</li>
                        <li>Applied Physics</li>
                        <li>General Pathology</li>
                        <li>Clinical Pathology</li>
                        <li>Internal Medicine (Semeiotics & Medical Pathophysiology)</li>
                        <li>General Surgery and Surgical Semeiotics</li>
                        <li>Professionalizing Activities</li>
                        <li>Elective Teaching Activities (Medicine & Biomedical Engineering)</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <ul>
                        <li>Cardiovascular Diseases</li>
                        <li>Cardiac Surgery</li>
                        <li>Respiratory System Diseases</li>
                        <li>Blood Diseases</li>
                        <li>Pathological Anatomy</li>
                        <li>Nephrology</li>
                        <li>Urology</li>
                        <li>Mathematical Models in Medicine</li>
                        <li>Public Health</li>
                        <li>Pharmacology II</li>
                        <li>Data Science for Bioengineering</li>
                        <li>Gastroenterology</li>
                        <li>Endocrinology</li>
                        <li>General Surgery & New Techniques in Surgery (Minimally Invasive & Robotic Surgery)</li>
                        <li>Professionalizing Activities</li>
                        <li>Elective Teaching Activities (Medicine & Biomedical Engineering)</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <ul>
                        <li>Oncology</li>
                        <li>Genetic Medicine</li>
                        <li>Internal Medicine (Immune System)</li>
                        <li>Neurology</li>
                        <li>Neuroradiology</li>
                        <li>Neurosurgery</li>
                        <li>Psychiatry</li>
                        <li>Radiology and Interventional Radiology</li>
                        <li>Nuclear Medicine & Radiotherapy</li>
                        <li>Electronic and Computer Bioengineering</li>
                        <li>Oral Diseases</li>
                        <li>Ophthalmology</li>
                        <li>Otolaryngology</li>
                        <li>Infectious Diseases</li>
                        <li>Dermatology & Plastic Surgery</li>
                        <li>Musculoskeletal System Diseases</li>
                        <li>Physical and Rehabilitation Medicine</li>
                        <li>Rheumatology</li>
                        <li>Industrial Bioengineering</li>
                        <li>Professionalizing Activities</li>
                        <li>Elective Teaching Activities (Medicine & Biomedical Engineering)</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Clinical Medicine & Medical and Molecular Therapy</li>
                        <li>Clinical Surgery</li>
                        <li>Clinical Biochemistry & Clinical Molecular Biology</li>
                        <li>Clinical Pathology</li>
                        <li>Pediatric Medicine</li>
                        <li>Pediatric Surgery</li>
                        <li>Gynecology and Obstetrics</li>
                        <li>Geriatrics</li>
                        <li>Clinical Geriatric Surgery</li>
                        <li>Electronic and Computer Bioengineering</li>
                        <li>Anesthesiology</li>
                        <li>Medical Emergencies</li>
                        <li>Surgical Emergencies</li>
                        <li>Forensic Medicine</li>
                        <li>Occupational Medicine</li>
                        <li>Professionalizing Activities</li>
                        <li>Foreign Language</li>
                        <li>Final Test</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams and Grading System</h2>
                    <p>Throughout the six-year program, students are assessed through written, oral, and practical exams. These exams are designed to evaluate both the students' understanding of theoretical knowledge and their ability to apply that knowledge in clinical settings. Practical exams during clinical rotations test students' ability to work with patients and perform medical procedures.</p>
                    <p>The grading system at Università Politecnica delle Marche follows a 30-point scale:</p>
                    <ul>
                        <li>18/30 is the minimum passing grade.</li>
                        <li>30/30 cum laude is the highest grade.</li>
                    </ul>
                </section>

                <section className="scholarships">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p>The amount of the first instalment for the academic year is uniquely defined for all students and is equal to 156,00 euros, made of the sum of a regional tax and of a revenue stamps, fee usually depends on the student's financial situation (ISEE indicator). Scholarships are available for both EU and non-EU students, based on academic merit and financial need.</p>
                    <h3>ERDIS Scholarships</h3>
                    <p>The Regional Agency for the Right to Higher Education (ERDiS) gives you the possibility to obtain benefits related to accommodation, scholarships and canteen every year, on the basis of income and merit criteria.</p>
                    <a href="https://erdis.it/servizi/servizio-dettaglio/3161252">ERDIS Scholarships</a>
                </section>

                <section className="city-info">
                    <h2>Life in Ancona and Living Costs</h2>
                    <p>Studying in Ancona, where Università Politecnica delle Marche is located, offers students a high-quality education in a beautiful coastal city with a rich history. Ancona is known for its stunning Adriatic coastline, providing students with access to beautiful beaches and outdoor activities. The city has a relaxed and student-friendly atmosphere, with plenty of cafés, restaurants, and cultural attractions. It is also home to several historical landmarks, including the Arch of Trajan, the Cathedral of San Ciriaco, and the Lazzaretto of Ancona.</p>
                    <h3>Estimated Monthly Expenses</h3>
                    <ul>
                        <li><strong>Average cost for a single room:</strong> €200</li>
                        <li><strong>Full meal in the university canteen:</strong> €4-7</li>
                        <li><strong>Pizza Margherita:</strong> €4.50</li>
                        <li><strong>Breakfast in a bar (croissant and cappuccino):</strong> €2.30</li>
                        <li><strong>Bus ticket:</strong> €1.25</li>
                        <li><strong>Single train ticket to Rome:</strong> €20.00</li>
                        <li><strong>Club Entrance:</strong> €10</li>
                        <li><strong>Cinema ticket:</strong> €6-9</li>
                        <li><strong>Beer in a pub:</strong> €3.50</li>
                    </ul>
                    <p>Total estimated monthly cost: €500-600.</p>
                    <a href="https://www.univpm.it/Entra/Services_for_students/Territory_and_more_info/Cost_of_living_1">Cost of Living in Ancona</a>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The Medicine and Surgery program at Università Politecnica delle Marche is the perfect choice for students looking for a future-oriented medical education. By integrating medical science with engineering and advanced technology, the program prepares graduates to become leaders in modern medicine. With excellent training facilities, cutting-edge research opportunities, and a supportive learning environment, this program stands as a unique and prestigious option for aspiring doctors worldwide.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage4;